module.exports = __webpack_public_path__ + "img/google-icon.f3ca30fe.svg";